/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ToggleIsSSOMandatory_company$ref = any;
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type settingsAppCatalog_viewer$ref: FragmentReference;
declare export opaque type settingsAppCatalog_viewer$fragmentType: settingsAppCatalog_viewer$ref;
export type settingsAppCatalog_viewer = {|
  +company: ?{|
    +tier: ?TierType,
    +$fragmentRefs: ToggleIsSSOMandatory_company$ref,
  |},
  +$refType: settingsAppCatalog_viewer$ref,
|};
export type settingsAppCatalog_viewer$data = settingsAppCatalog_viewer;
export type settingsAppCatalog_viewer$key = {
  +$data?: settingsAppCatalog_viewer$data,
  +$fragmentRefs: settingsAppCatalog_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsAppCatalog_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ToggleIsSSOMandatory_company"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = 'a5c89931768d7ade2a2d029ee8c1ae00';

module.exports = node;
